"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H3v-3h10v3zm0-4H3V2h10v8z"];
//# sourceMappingURL=widget-footer.js.map